import gql from 'graphql-tag'

export const GET_TRAVELTIME2 = gql`
    query TravelTime2($payload: TravelTime2Payload!) {
        travelTime2(payload: $payload)
    }
`

export const GET_TRAVELTIME = gql`
    query TravelTime($payload: TravelTimePayload!) {
        travelTime(payload: $payload) {
            results {
                search_id
                shapes {
                    shell {
                        lat
                        lng
                    }
                    holes {
                        lat
                        lng
                    }
                }
            }
        }
    }
`

export const AUTOCOMPLETE = gql`
    query Search($term: String! $session: String! $provinceCode: String) {
        addressAutocomplete(term: $term session: $session) {
            resultCount
            results {
                description
                place_id
                matched_substrings
                reference
                structured_formatting
                terms
                types
            }
        }
        search(term: $term provinceCode: $provinceCode) {
            resultCount
            results {
                contactName
                companyName
                address
                city
                province
                postal
                phone
                score
                id
            }
        }
    }
`

export const GET_PLACE_DETAILS = gql`
    query GetPlaceDetails($placeId: String! $session: String!) {
        placeDetails(placeId: $placeId session: $session) {
            geometry {
                location {
                    lat
                    lng
                }
                viewport {
                    northeast {
                        lat
                        lng
                    }
                    southwest {
                        lat
                        lng
                    }
                }
            }
        }
    }
`

export const GET_MAP_PINS = gql`
    query mapPins($limit: Int $offset: Int $provinceCode: String) {
        mapPins(limit: $limit offset: $offset provinceCode: $provinceCode) {
            id
            latitude
            lat
            lng
            longitude
            channelSegment
            mapType
            subMapType
            companyName
            googlePlaceId
        }
    }
`

export const GET_LOCATION_DATA = gql`
    query locations($ids: [ID]!) {
        locations(ids: $ids) {
            id
            channelSegment
            mapType
            subMapType
            companyName
            address
            suiteNumber
            city
            province
            provinceCode
            postal
            phone
            contactName
            title
            gender
            locationSalesVolume
            locationEmploymentSize
            creditRating
            partsPotential
        }
    }
`

export const GET_LOCATION_INFO = gql`
    query location($id: ID!) {
        location(id: $id) {
            id
            latitude
            longitude
            channelSegment
            mapType
            subMapType
            companyName
            address
            suiteNumber
            city
            province
            provinceCode
            postal
            phone
            contactName
            title
            gender
            locationSalesVolume
            locationEmploymentSize
            creditRating
            partsPotential
            placeDetails
        }
    }
`

export const UPDATE_LOCATION = gql`
    mutation UpdateLocation($payload: UpdateLocationPayload) {
        updateLocation(payload: $payload) {
            id
            latitude
            longitude
        }
    }
`